import { useEffect } from "react";

// iPhones do not shrink the page when the keyboard opens (Safari ignores interactive-widget), so a
// composer pinned to the bottom ends up behind the keyboard. Follow the visual viewport instead.
// Android Chrome already resizes the page, so there the visual viewport matches the window and
// nothing is overridden.
export default function useKeyboardFit(ref) {
  useEffect(() => {
    const vv = typeof window !== "undefined" ? window.visualViewport : null;
    const el = ref.current;
    if (!vv || !el) return undefined;

    const reset = () => {
      el.style.height = "";
      el.style.top = "";
      el.style.bottom = "";
    };

    const update = () => {
      const covered = window.innerHeight - vv.height;
      if (covered > 80) {
        // large enough to be a keyboard, not just a collapsing address bar
        el.style.height = `${vv.height}px`;
        el.style.top = `${vv.offsetTop}px`;
        el.style.bottom = "auto";
      } else {
        reset();
      }
    };

    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    update();
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      reset();
    };
  }, [ref]);
}
